module.exports = ".add-muliti-des{position:absolute;right:-14px;bottom:30px}.remove-muliti-des{position:absolute;right:-29px;top:25px;color:red}"